var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMenuList = function SvgIconMenuList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 2.8C2.1732 2.8 2.8 2.1732 2.8 1.4C2.8 0.626801 2.1732 0 1.4 0C0.626801 0 0 0.626801 0 1.4C0 2.1732 0.626801 2.8 1.4 2.8Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 9.20002C2.1732 9.20002 2.8 8.57322 2.8 7.80002C2.8 7.02683 2.1732 6.40002 1.4 6.40002C0.626801 6.40002 0 7.02683 0 7.80002C0 8.57322 0.626801 9.20002 1.4 9.20002Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 15.6C2.1732 15.6 2.8 14.9732 2.8 14.2C2.8 13.4269 2.1732 12.8 1.4 12.8C0.626801 12.8 0 13.4269 0 14.2C0 14.9732 0.626801 15.6 1.4 15.6Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 1.59998H16",
    stroke: "black",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 8H16",
    stroke: "black",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 14.4H16",
    stroke: "black",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconMenuList;